export const FETCH_APPOINTMENT_TYPES = 'FETCH_APPOINTMENT_TYPES';
export const FETCH_APPOINTMENTS = 'FETCH_APPOINTMENTS';
export const FETCH_SYMPTOM_TYPES = 'FETCH_SYMPTOM_TYPES';
export const UPLOAD_LETTERS = 'UPLOAD_LETTERS';
export const APPOINTMENT_LOADER = 'APPOINTMENT_LOADER';
export const CREATE_APPOINTMENT_SUCCESS = 'CREATE_APPOINTMENT_SUCCESS';
export const CREATE_APPOINTMENT_ERROR = 'CREATE_APPOINTMENT_ERROR';
export const ERROR_RESET = 'ERROR_RESET';
export const FETCH_APPOINTMENT_ARTICLES = 'FETCH_APPOINTMENT_ARTICLES';
export const UPLOAD_MEDICAL_RECORDS = 'UPLOAD_MEDICAL_RECORDS';
export const CREATE_MEDICAL_RECORDS_SUCCESS = 'CREATE_MEDICAL_RECORDS_SUCCESS';
export const CREATE_MEDICAL_RECORDS_ERROR = 'CREATE_MEDICAL_RECORDS_ERROR';
export const FORM_RESET = 'FORM_RESET';
export const GET_FILE_URL = 'GET_FILE_URL';
export const GET_FILE_URL_ERROR = 'GET_FILE_URL_ERROR';
export const FETCH_APPOINTMENT_ORDERS = 'FETCH_APPOINTMENT_ORDERS';
export const FETCH_MEDICAL_DOCUMENTS = 'FETCH_MEDICAL_DOCUMENTS';
export const FETCH_APPOINTMENT_REPORTS = 'FETCH_APPOINTMENT_REPORTS';
export const INITIATE_APPOINTMENT_REPORTS_FETCH =
  'INITIATE_APPOINTMENT_REPORTS_FETCH';
export const INITIATE_GENERATE_REPORT = 'INITIATE_GENERATE_REPORT';
export const GENERATE_ENCOUNTER_REPORT = 'GENERATE_ENCOUNTER_REPORT';
export const FETCH_APPOINTMENT_FAX_LOGS = 'FETCH_APPOINTMENT_FAX_LOGS';
export const FETCH_APPOINTMENT_FAX_LOGS_SUCCESS =
  'FETCH_APPOINTMENT_FAX_LOGS_SUCCESS';
export const PUT_MRR_FILES = 'PUT_MRR_FILES';
export const DOWNLOAD_ARCHIEVE = 'DOWNLOAD_ARCHIEVE';
export const DOWNLOAD_S3_ACCESS_URL = 'DOWNLOAD_S3_ACCESS_URL';
